import { AssetCategory, AssetType, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { Filters } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
export const assetCodesByAssetClass = Object.freeze(new Map([
    ["equity", AssetCategory.Equity],
    ["equity related", AssetCategory.Equity],
    ["fixed income", AssetCategory.FixedIncome],
    ["derivatives", AssetCategory.Derivatives],
    ["managed portfolio", AssetCategory.ManagedPortfolio],
    ["managed portfolios", AssetCategory.ManagedPortfolio],
    ["real estate", AssetCategory.RealEstate],
    ["commodity", AssetCategory.Commodity],
    ["Commodities", AssetCategory.Commodity],
    ["life insurance", AssetCategory.LifeInsurance],
    ["total", AssetCategory.Total],
]));
const holdingCommonFilters = [
    { title: "Tradeable holdings", key: "tradable", selected: false },
    { title: "Pledged Scrips", key: "normalMarginPledge", selected: false },
    { title: "CUSA Scrips", key: "Cusa", selected: false },
    { title: "MTF Scrips", key: "mtf", selected: false },
];
const holdingAssets = [
    { title: "Equity", key: AssetCategory.Equity, selected: false },
    { title: "Fixed Income", key: AssetCategory.FixedIncome, selected: false },
    {
        title: "Managed Portfolio",
        key: AssetCategory.ManagedPortfolio,
        selected: false,
    },
    {
        title: "Life Insurance",
        key: AssetCategory.LifeInsurance,
        selected: false,
    },
    { title: "Commodity", key: AssetCategory.Commodity, selected: false },
    { title: "Real Estate", key: AssetCategory.RealEstate, selected: false },
];
export const simpleFilter = new Filters("Scrip Filter", holdingCommonFilters);
export const assetFilter = new Filters("Asset filter", holdingAssets);
const equityProduct = [
    { display: "Listed Equity", value: AssetType.EQ },
    { display: "Unlisted Equity", value: AssetType.UnlistedEquity },
];
const fixedIncomeProducts = [
    { display: "Certificate Of Deposit", value: AssetType.CertOfDeposit },
    { display: "Commercial Paper", value: AssetType.CommPaper },
    { display: "NCD", value: AssetType.NCD },
    { display: "Warrant", value: AssetType.Warrant },
    { display: "Bonds", value: AssetType.Bonds },
    { display: "Debentures", value: AssetType.Debentures },
    {
        display: "Indian Depository Receipt",
        value: AssetType.IndianDepoReceipt,
    },
    { display: "Preference Share", value: AssetType.PreferenceShare },
    { display: "Corp FD", value: AssetType.CorpFD },
    { display: "RBI Bonds", value: AssetType.RBIBonds },
    { display: "54 EC", value: AssetType.EC54 },
    { display: "Govt. Securities", value: AssetType.GovtSecurity },
    { display: "Treasury Bills", value: AssetType.TreasuryBills },
];
const derivativesProducts = [
    { display: "Equity", value: AssetType.DEquity },
    { display: "Currency", value: AssetType.DCurrency },
    { display: "Commodity", value: AssetType.DCommodity },
];
const managedPortfolioProducts = [
    { display: "PMS", value: AssetType.PMS },
    { display: "Mutual Fund", value: AssetType.MutualFund },
    { display: "ETF", value: AssetType.ETF },
    { display: "INVITS", value: AssetType.INVITS },
    { display: "AIF", value: AssetType.AIF },
    { display: "Structured Products", value: AssetType.StructuredProducts },
];
const lifeInsuranceProducts = [
    {
        display: "Saving & Investment Insurance",
        value: AssetType.savingNinvInsurance,
    },
];
const realEstateProducts = [
    { display: "Real Estate", value: AssetType.RealEstate },
];
const commodityProducts = [
    { display: "Commodities", value: AssetType.Commodity },
];
export const assetWiseProducts = new Map([
    [AssetCategory.Equity, equityProduct],
    [AssetCategory.FixedIncome, fixedIncomeProducts],
    [AssetCategory.Derivatives, derivativesProducts],
    [AssetCategory.ManagedPortfolio, managedPortfolioProducts],
    [AssetCategory.LifeInsurance, lifeInsuranceProducts],
    [AssetCategory.RealEstate, realEstateProducts],
    [AssetCategory.Commodity, commodityProducts],
    [AssetCategory.Others, [...realEstateProducts, ...commodityProducts]],
    [
        AssetCategory.Total,
        [
            ...equityProduct,
            ...fixedIncomeProducts,
            ...managedPortfolioProducts,
            ...lifeInsuranceProducts,
            ...realEstateProducts,
            ...commodityProducts,
        ],
    ],
]);
